import { defineComponent as _defineComponent } from 'vue'
import LAvatar from '@/global-components/LAvatar.vue'

interface AccountCardProps {
  imageUrl?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountCard',
  props: {
    imageUrl: null
  },
  setup(__props: any) {



return { __sfc: true,LAvatar }
}

})